import React, { Dispatch, FC } from 'react';
import { Box } from '@mui/material';
import { FelixMessageSVG } from '../../SharedComponents/Graphics/FelixSVG';
import { classes } from '../styles';
import { SmartShareAction, SmartShareState } from '../reducer';
import { FeedbackInput } from '../../AIStudioModal/components/FeedbackInput';

const SUGGESTED_PROMPTS_JOB_BOARD = [
  'Optimise for LinkedIn',
  'Make it stand out',
  'Focus on salary and benefits',
  'Use bullet points',
  'Make it concise and scannable'
];

const SUGGESTED_PROMPTS_SOCIAL = [
  'Use a conversational tone',
  'Add hashtags',
  'Include a call to action',
  'Make it more fun',
  'Include emojis',
  'Target Gen Z audience',
  'Make it shorter',
  'Promote company culture'
];

interface ResponseFooterProps {
  dispatch: Dispatch<SmartShareAction>;
  smartShareState: SmartShareState;
  generatePost: (feedbackInput?: string) => void;
  generateSummary: (feedbackInput?: string) => void;
}

const ResponseFooter: FC<ResponseFooterProps> = ({
  smartShareState,
  dispatch,
  generatePost,
  generateSummary
}) => {
  const handleGenerateQuestions = (input: string) => {
    if (smartShareState.generationType === 'social') {
      generatePost(input);
    } else {
      generateSummary(input);
    }
  };

  return (
    <Box sx={classes.footerContainer}>
      <Box sx={classes.felixMessageContainer}>
        <FelixMessageSVG />
        <Box sx={{ ...classes.felixMessage, maxWidth: 'initial' }}>
          {smartShareState.generationType === 'social' ? (
            <>
              Your draft <span>social media post</span> is ready to roll! You may want to use this
              as is, or make some adjustments before publishing.
            </>
          ) : (
            <>
              Your draft <span>job board advertisement</span> is ready to roll! You may want to use
              this as is, or make some adjustments before publishing.
            </>
          )}

          <FeedbackInput
            value={smartShareState.refinedResponse}
            onChange={(value) => dispatch({ type: 'SET_REFINED_RESPONSE', payload: value })}
            suggestedPrompts={
              smartShareState.generationType === 'social'
                ? SUGGESTED_PROMPTS_SOCIAL
                : SUGGESTED_PROMPTS_JOB_BOARD
            }
            onSubmit={handleGenerateQuestions}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ResponseFooter;
